<template>
    <div>
        <div>
            <h6>数据更新日期： {{staticDate == null?'未更新':staticDate}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;总金额：{{totalMoney }} </h6>
        </div>
        <div class="acount-grid" >
            <div class="acount-item" v-for="acount in acounts" :key="acount.id">
                <div   >
                  <span style="font-weight: bold;">{{ acount.companyName }}
                    <br/>
                    <span style="font-size: larger;color: #409eff;">{{ acount.money== null?0:acount.money}}元 </span>
                  </span>
                </div>
            </div>
        </div>
        <div >
            <div style="display: flex;justify-content: flex-end">
                    <!-- <el-upload
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="onSuccess"
                            :on-error="onError"
                            :disabled="importDataDisabled"
                            style="display: inline-flex;margin-right: 8px"
                            action="/employee/basic/import">
                        <el-button :disabled="importDataDisabled" type="success" :icon="importDataBtnIcon">
                            {{importDataBtnText}}
                        </el-button>
                    </el-upload> -->
                    <!-- <el-button type="success" @click="importData" icon="el-icon-download">
                        {{importDataBtnText}}
                    </el-button> -->
                    <el-button type="primary" icon="el-icon-plus" @click="showAddEmpView">
                        添加流水
                    </el-button>
            </div>
            <transition name="slide-fade">
                <div  
                    style="display: none; border: 1px solid #409eff;border-radius: 5px;box-sizing: border-box;padding: 5px;margin: 10px 0px;">
                    <el-row>
                        <el-col :span="4">
                            收方名称:
                            <el-input v-model="searchValue.projectName" placeholder="项目名称" clearable size="mini"
                                style="width: 150px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            付方名称:
                            <el-input v-model="searchValue.projectMaster" placeholder="项目经理" size="mini"
                                style="width: 150px;"></el-input>
                        </el-col>
                        <el-col :span="4">
                            金额:
                            <el-input v-model="searchValue.projectMaster" placeholder="项目经理" size="mini"
                                style="width: 130px;"></el-input>
                        </el-col>
                        <el-col :span="7">
                            交易日期:
                            <el-date-picker v-model="searchValue.beginDateScope" type="daterange" size="mini" unlink-panels
                                value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="3" :offset="1">
                            <el-button size="mini">取消</el-button>
                            <el-button size="mini" icon="el-icon-search" type="primary"
                                @click="initEmps('clear')">搜索</el-button>
                        </el-col>
                    </el-row>
                </div>
            </transition>
        </div>
        <!-- 标题列 --->
        <div style="margin-top: 10px">
            <el-table :data="emps" stripe border v-loading="loading" element-loading-text="正在加载..."
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" ref="projectTable"
                style="width: 100%" :row-key="row => row.projectCode" @selection-change="handleSelectionChange"
                :header-cell-style="{ 'text-align': 'center' }">

                <el-table-column prop="sellerName" fixed align="center" label="收方名称" width="280">
                </el-table-column>
                <el-table-column prop="sellerNo" width="200" align="center" label="收方账号">
                </el-table-column>
                <el-table-column prop="payerName" width="280" align="center" label="付方名称">
                </el-table-column>
                <el-table-column prop="payerNo" width="200" align="center" label="付方账号">
                </el-table-column>
                <el-table-column prop="amount" width="120" align="center" label="金额">
                </el-table-column>
                <el-table-column prop="type" width="80" align="center" label="款项类型">
                </el-table-column>
                <el-table-column prop="tradeTime" width="120" align="center" label="交易日期">
                </el-table-column>
                <el-table-column prop="cTime" width="120" align="center" label="入库时间">
                </el-table-column>
                <el-table-column fixed="right" align="center" width="160" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="showEditEmpView(scope.row)" v-if="scope.row.plat == '01'" style="padding: 3px"
                            size="mini">补单</el-button>
                        <el-button @click="showEditEmpView(scope.row)" style="padding: 3px" size="mini">编辑</el-button>
                        <!-- <el-button style="padding: 3px" size="mini" type="primary">查看高级资料</el-button> -->
                        <el-button @click="deleteEmp(scope.row)" style="padding: 3px" size="mini" type="danger">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: flex-end">
                <el-pagination background @current-change="currentChange" @size-change="sizeChange"
                    :current-page.sync="page" layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 上传项目文件弹窗 -->
        <!--================================上传文件弹窗=========================-->
        <el-dialog :title="addFileTitleName" :visible.sync="importDataDisabled" width="500px" style="padding:0;"
            @close="resetAddFile">
            <div class="add-file-right">
            </div>
            <!-- <el-input v-model="addFileName" autocomplete="off" size="small" style="width: 300px; display: none;" ></el-input> -->

            <div class="add-file-right" style="margin-top: 20px;">
                <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt"
                    class="add-file-right-input" style="margin-left:60px;margin-top: 20px;" accept=".xlsx">
                <div style="margin-top: 20px;">
                    <span class="add-file-right-more">支持扩展名：.xlsx</span>
                </div>
                <div style="margin-top: 10px;">
                    <span class="add-file-right-more">注意：表中必须含有"项目名称"字段,前程和销售单需要注意</span>
                </div>
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in addArr" :key="index"><a>{{ item.name }}</a></li>
                </ul>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitAddFile" size="small">开始上传</el-button>
                <el-button @click="resetAddFile" size="small">全部删除</el-button>
            </div>

        </el-dialog>


        <el-dialog :title="title" :visible.sync="dialogVisible" :modal-append-to-body="false" :close-on-click-modal="false"
            width="30%">
            <div>
                <el-form :model="emp" :rules="rules" label-width="150px" ref="empForm">
                    <el-form-item label="收方名称:" prop="materialName">
                        <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.materialName"
                            placeholder="请输入商品名称"></el-input>
                    </el-form-item>
                
                <el-form-item label="收方账号:" prop="materialName">
                    <el-input size="mini" style="width: 150px" prefix-icon="el-icon-edit" v-model="emp.materialName"
                        placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="付方名称:" prop="pCode">
                    <el-select size="mini" style="width: 180px" v-model="emp.pCode" filterable  @change="$forceUpdate()"  placeholder="请选择">
                        <el-option 
                                v-for="(r,indexk) in banks"
                                :key="r.pCode"
                                :label="r.pName"
                                :value="r.pCode">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="doAddEmp">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "projectInfo",
    data() {
        return {
            totalMoney: 0,
            searchValue: {
                politicId: null,
                nationId: null,
                jobLevelId: null,
                posId: null,
                engageForm: null,
                departmentId: null,
                beginDateScope: null
            },
            typeList: [],
            title: '',
            importDataBtnText: '导入数据',
            importDataBtnIcon: 'el-icon-upload2',
            importDataDisabled: false,
            showAdvanceSearchView: false,
            allDeps: [],
            upFilePlat: '',
            addFileTitleName: "上传文件窗口",
            addFileName: "",
            addArr: [],
            emps: [],
            banks:[],
            loading: false,
            popVisible: false,
            popVisible2: false,
            dialogVisible: false,
            total: 0,
            page: 1,
            keyword: '',
            size: 10,
            nations: [],
            joblevels: [],
            politicsstatus: [],
            positions: [],
            acounts: [],
            tiptopDegrees: ['本科', '大专', '硕士', '博士', '高中', '初中', '小学', '其他'],
            options: [],
            inputDepName: '所属部门',
            emp: {
                workAge: null
            },
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            rules: {
                materialName: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
                unit: [{ required: false, message: '请输入商品规格', trigger: 'blur' }],
                type: [{ required: true, message: '请选择商品类型', trigger: 'blur' }],
                minLimit: [{ required: true, message: '请输入起订量', trigger: 'blur' }],
                price: [{ required: true, message: '请输入价格', trigger: 'blur' }
                    , { pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/, message: '请输入正确的格式,可保留两位小数' }],
            }
        }
    },
    mounted() {
        this.initEmps();
        this.initAcountInfo();
    },
    methods: {
        searvhViewHandleNodeClick(data) {
            this.inputDepName = data.name;
            this.searchValue.departmentId = data.id;
            this.popVisible2 = !this.popVisible2
        },
        rowKey(row) {
            console.log(row.projectCode)
            row.projectCode;
        },
        handleSelectionChange(val) {
            console.log(val)
        },
        //1、使用插槽（推荐）
        getChangeType(e, z) {

            if ('type' == z) {
                for (var i = 0; i < this.typeList.length; i++) {
                    if (this.typeList[i].dictValue == e) { //dictValue，dictLabel保持和上面定义一致
                        return this.typeList[i].dictLabel;
                    }
                }
            }

        },

        onError(err, file, fileList) {
            this.importDataBtnText = '导入数据';
            this.importDataBtnIcon = 'el-icon-upload2';
            this.importDataDisabled = false;
        },
        onSuccess(response, file, fileList) {
            this.importDataBtnText = '导入数据';
            this.importDataBtnIcon = 'el-icon-upload2';
            this.importDataDisabled = false;
            this.initEmps();
        },
        beforeUpload() {
            this.importDataBtnText = '正在导入';
            this.importDataBtnIcon = 'el-icon-loading';
            this.importDataDisabled = true;
        },
        importData() {
            this.importDataDisabled = true;
        },
        emptyEmp() {
            this.emp = {

            }
            this.inputDepName = '';
        },
        showEditEmpView(data) {
            this.title = '编辑商品信息';
            this.emp = data;
            this.dialogVisible = true;
        },
        deleteEmp(data) {
            this.$confirm('此操作将永久删除【' + data.materialName + '】, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRequest("/yl/material/" + data.materialCode).then(resp => {
                    if (resp) {
                        this.initEmps('clear');
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        doAddEmp() {
            if (this.emp.id) {
                this.$refs['empForm'].validate(valid => {
                    if (valid) {
                        this.putRequest("/yl/material", this.emp).then(resp => {
                            if (resp) {
                                this.dialogVisible = false;
                                this.initEmps();
                            }
                        })
                    }
                });
            } else {
                this.$refs['empForm'].validate(valid => {
                    if (valid) {
                        this.postRequest("/yl/material", this.emp).then(resp => {
                            if (resp) {
                                this.dialogVisible = false;
                                this.initEmps();
                            }
                        })
                    }
                });
            }
        },
        handleNodeClick(data) {
            this.inputDepName = data.name;
            this.emp.departmentId = data.id;
            this.popVisible = !this.popVisible
        },
        showDepView() {
            this.popVisible = !this.popVisible
        },
        showDepView2() {
            this.popVisible2 = !this.popVisible2
        },
        sizeChange(currentSize) {
            this.size = currentSize;
            this.initEmps();
        },
        currentChange(currentPage) {
            this.page = currentPage;
            this.initEmps('advanced');
        },
        showAddEmpView() {
            this.emptyEmp();
            this.title = '添加流水';
            this.dialogVisible = true;
        },
        initEmps(type) {
            if (type === 'clear') {
                this.page = 1;
            }
            this.loading = true;
            // let reqParam = {projectNameLike:this.keyword};
            this.searchValue['materialName'] = this.keyword
            this.searchValue['pageNo'] = this.page
            this.searchValue['pageSize'] = this.size
            this.postRequest('/yl/trade/getTrade', this.searchValue).then(resp => {
                this.loading = false;
                if (resp) {
                    this.emps = resp.data;
                    for(let a in this.emps){
                        if(this.emps[a].amount >= 0){
                            this.emps[a].type = '收入'
                        }else{
                            this.emps[a].type = '支出';
                        }
                    }
                    this.total = resp.total;
                }
            });
        },
        initAcountInfo() {
            this.getRequest('/yl/trade/staticMoney').then(resp => {
                if (resp) {
                    this.acounts = resp.data;
                    for(let index in resp.data){
                        this.banks=[];
                        this.banks.push({"pName":resp.data[index].companyName,
                                         "pCode":resp.data[index].companyNo});
                                         
                    }
                    this.showTotalMoney();
                }
            });
            
        },
        showTotalMoney(){
            let total = 0;
            for(let a in this.acounts){
                total = this.accAdd(this.acounts[a].money,total);
            }
            this.staticDate= this.acounts[0].emailDate;
            this.totalMoney = total;
        },
        /*用来得到精确的加法结果
        *说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
        *调用：accAdd(arg1,arg2)
        *返回值：arg1加上arg2的精确结果
        */
        accAdd(arg1,arg2){
            var r1,r2,m;
            try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0}
            try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0}
            m=Math.pow(10,Math.max(r1,r2))
            return (arg1*m+arg2*m)/m
        },
        //==================上传文件操作函数=============================================
        getFile(event) {
            //获取上传文件方法    
            var file = event.target.files;
            for (var i = 0; i < file.length; i++) {
                //    上传类型判断        
                var imgName = file[i].name;
                var idx = imgName.lastIndexOf(".");
                if (idx != -1) {
                    var ext = imgName.substr(idx + 1).toUpperCase();
                    ext = ext.toLowerCase();
                    //pdg,doc,docx.xls,.xlsx,.ppt,pptx,            
                    if (ext != 'xlsx') {

                    } else {
                        this.addArr.push(file[i]);
                    }
                } else {

                }
            }
        },
        submitAddFile() {
            //===========提交上传文件到后台保存方法    
            if (0 == this.addArr.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            }
            var formData = new FormData();
            for (var i = 0; i < this.addArr.length; i++) {
                formData.append('files', this.addArr[i]);
            }
            formData.append('plat', this.upFilePlat);
            let config = {
                headers: { "Content-Type": "multipart/form-data" }
            };
            console.log(formData);
            //接口请求使用的是自己封装了一下的axios    
            this.postRequest('/yl/qun/importProject', formData, config).then(res => {
                console.log(res);
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
            }).catch((error) => {
                alert("操作失败，出现错误：" + error)
            });
        },
        //清除上传的文件方法
        resetAddFile() {
            this.addFileName = "";
            this.addArr = [];
            this.upFilePlat = "";
            this.$refs.clearFile.value = ''
        },

    }
}
</script>

<style>
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
    transition: all .8s ease;
}

.slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for below version 2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}
.acount-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0px 20px 0px 20px;
  }
.acount-item {
    flex: 0 0 25%; /* 控制每个商品项的宽度，这里设置为24%，可根据需要调整 */
    margin-bottom: 10px; /* 商品项之间的间距 */
    text-align: center;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
</style>
